import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthProvider";
import styles from "./Sidebar.module.css";
import { FaSignOutAlt, FaHome } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import {
  FaEllipsis,
  FaStore,
  FaPlus,
  FaUser,
  FaBoxArchive,
  FaPaintbrush,
} from "react-icons/fa6";
import ThemeSelector from "../Inputs/ThemeSelector/ThemeSelector";
import React from "react";
import LangSelector from "../Inputs/LangSelector/LangSelector";

const Sidebar: React.FC<{ scrolled: boolean }> = ({ scrolled }) => {
  const { logout, user } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false); // State to toggle dropdown
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  return (
    <nav className={`${styles.sidebar} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.container}>
        {/* <img src={logo} /> */}
        <div className={`${styles.navTop}`}>
          <NavLink
            to="/"
            className={({ isActive }: { isActive: boolean }) =>
              isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
            }
          >
            <div className={styles.iconWrapper}>
              <FaHome />
            </div>
            <div className={styles.label}>{t("explore.label")}</div>
          </NavLink>
          {user && (
            <>
              {/* <NavLink
                to="/user/messages"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                <div className={styles.iconWrapper}>
                  <FaMessage />
                </div>
                <div className={styles.label}>Messages</div>
              </NavLink> */}
              <NavLink
                to="/store"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                <div className={styles.iconWrapper}>
                  <FaStore />{" "}
                </div>
                <div className={styles.label}>{t("store.label")}</div>
              </NavLink>
              <NavLink
                to="/creator/cards"
                end
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                <div className={styles.iconWrapper}>
                  <FaHome />
                </div>
                <div className={styles.label}>{t("creator.label")}</div>
              </NavLink>
              <NavLink
                to="/creator/cards/create"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                {({ isActive }: { isActive: boolean }) => (
                  <button
                    className={`${styles.button} ${
                      isActive ? styles.buttonActive : ""
                    }`}
                  >
                    <div className={styles.iconWrapper}>
                      <FaPlus />
                    </div>
                    <div>{t("cards.label")}</div>
                  </button>
                )}
              </NavLink>
              <NavLink
                to="/creator/boosters/create"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                {({ isActive }: { isActive: boolean }) => (
                  <button
                    className={`${styles.button} ${
                      isActive ? styles.buttonActive : ""
                    }`}
                  >
                    <div className={styles.iconWrapper}>
                      <FaPlus />
                    </div>
                    <div>{t("boosters.label")}</div>
                  </button>
                )}
              </NavLink>
              {/* TODO change to link  */}
              {/* <NavLink
                to="/posts/create"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                <div className={styles.button}>
                  <div className={styles.iconWrapper}>
                    <FaPlus />
                  </div>
                  <div className={styles.label}>Post</div>
                </div>
              </NavLink> */}
              <NavLink
                to="/Collection/boosters"
                className={({ isActive }: { isActive: boolean }) =>
                  isActive
                    ? `${styles.navLink} ${styles.active}`
                    : styles.navLink
                }
              >
                <div className={styles.iconWrapper}>
                  <FaHome />
                </div>
                <div className={styles.label}>{t("collection.label")}</div>
              </NavLink>
            </>
          )}
        </div>

        {user && (
          <div className={styles.profileSection}>
            <NavLink
              to={`/profile/${user.username}`}
              className={({ isActive }: { isActive: boolean }) =>
                isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
              }
            >
              <FaUser />
              <div className={styles.label}>{t("profile.label")}</div>
            </NavLink>
            <div className={styles.dropdownToggle} onClick={toggleDropdown}>
              <FaEllipsis />
            </div>
            {dropdownOpen && (
              <div className={styles.dropdownMenu} ref={dropdownRef}>
                <NavLink
                  to="/Archive"
                  className={({ isActive }: { isActive: boolean }) =>
                    isActive
                      ? `${styles.navLink} ${styles.active} ${styles.item}`
                      : `${styles.navLink} ${styles.item}`
                  }
                >
                  <div className={styles.iconWrapper}>
                    <FaBoxArchive />
                  </div>
                  <div>{t("archive")}</div>
                </NavLink>{" "}
                <div className={styles.item}>
                  <div className={styles.iconWrapper}>
                    <FaPaintbrush />
                  </div>
                  <div>{t("theme")}</div>
                </div>
                <div className={styles.themeContainer}>
                  <ThemeSelector />
                </div>
                <div className={styles.item}>
                  <div className={styles.iconWrapper}>
                    <FaPaintbrush />
                  </div>
                  <div>{t("language")}</div>{" "}
                </div>
                <LangSelector />
                {/* <hr /> */}
                <div className={styles.navLink}>
                  <button className={`${styles.logoutButton}`} onClick={logout}>
                    <div className={styles.iconWrapper}>
                      <FaSignOutAlt />
                    </div>
                    <div>{t("logout")}</div>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Sidebar;
